export default "__VITE_ASSET__d25c1372__"